import { NavLink } from 'react-router-dom';
import { cx } from '@/utils/cx';
import { Icon, type IconName } from '@/design-system/icons/Icon';

type Props = {
  to: string;
  label: string;
  icon: IconName;
  count?: number;
  alert?: boolean;
  end?: boolean;
};

export const NavItem = ({ to, label, icon, count, alert, end }: Props) => (
  <NavLink
    to={to}
    end={end}
    className={({ isActive }) => cx('nav-item', isActive && 'active')}
  >
    <Icon name={icon} size={19} className="ic" />
    <span>{label}</span>
    {count != null && <span className={cx('count', alert && 'alert')}>{count}</span>}
  </NavLink>
);
